import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  touchActivity,
  isSessionExpired,
  clearSession,
  isLoggedIn,
} from "../lib/session";

const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
  "click",
  "wheel",
];

const CHECK_INTERVAL_MS = 30 * 1000;

export function useSessionTimeout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleActivity = () => {
      if (isLoggedIn()) touchActivity();
    };

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, handleActivity, { passive: true }),
    );

    if (isLoggedIn()) touchActivity();

    const check = () => {
      if (!isLoggedIn()) return;

      if (isSessionExpired()) {
        clearSession();

        Swal.fire({
          title: "Sesi Berakhir",
          text: "Anda telah logout otomatis karena tidak ada aktivitas selama 30 menit.",
          icon: "warning",
          confirmButtonText: "Login Kembali",
        }).then(() => {
          navigate("/login", { replace: true });
        });
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL_MS);

    return () => {
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
      clearInterval(interval);
    };
  }, [navigate]);
}
